import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section className="py-24 bg-[#0A192F]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#F2F2F2] mb-4">
            Lo que opinan{' '}
            <span className="text-[#FFD700]">nuestros clientes</span>
          </h2>
          <p className="text-lg text-[#F2F2F2]/80 max-w-3xl mx-auto">
            La satisfacción de nuestros clientes es nuestra mejor garantía
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-[#F2F2F2]/5 backdrop-blur-sm p-8 rounded-xl border border-[#FFD700]/20 hover:border-[#FFD700]/40 transition-all hover:transform hover:scale-105"
            >
              <Quote className="w-10 h-10 text-[#FFD700] mb-4" />
              <p className="text-[#F2F2F2]/90 text-lg leading-relaxed mb-6">
                "{testimonial.text}"
              </p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[#F2F2F2] font-bold">{testimonial.name}</p>
                  <p className="text-[#F2F2F2]/60 text-sm">{testimonial.location}</p>
                </div>
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#FFD700] text-[#FFD700]" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;